module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-9.aac5c9ff.png";